import './GamingLibraryCard.css'
import {SecondaryButtons} from '../../components/buttons/Buttons'

const GamingLibraryCard = (props) => {
  return (
    <div className='gaming-library-card'>
      <ul>
        <li><img src={props.img} /></li>
        <li><h4>{props.title}</h4><span>{props.category}</span></li>
        <li><h4>date added</h4><span>{props.date_added}</span></li>
        <li><h4>currently</h4><span>{props.download}</span></li>
        <SecondaryButtons>
        <a>download</a>
        </SecondaryButtons>
        
      </ul>
    </div>
  )
}

export default GamingLibraryCard